window.app.directive("removeWhen", [
  "$parse",
  function($parse) {
    return {
      restrict: "A",
      scope: false,
      require: "",
      compile: function(element, attrs) {
        var parent, marker;
        var hidden = null;
        update(true);

        return function(scope, _element, _attrs) {
          scope.$watch(attrs.removeWhen, update);
          scope.$on("$destroy", function() {
            parent = undefined;
            marker = undefined;
          });
        };

        function update(hide) {
          console.log("show", !hide);
          // var show = expr(scope);
          if (hidden === hide) {
            return;
          }
          hidden = hide;
          parent = parent || element[0].parentElement;
          marker =
            marker ||
            parent.querySelector(".remove-when-target") ||
            document.createElement("div");
          if (hide) {
            setTimeout(function() {
              window.requestAnimationFrame(function() {
                parent.insertBefore(element[0], marker);
                parent.removeChild(marker);
              });
            }, 1000);
          } else {
            parent.insertBefore(marker, element[0]);
            parent.removeChild(element[0]);
          }
        }
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/removeWhen.js